<mt-button class="premium-purchase-button" variant="primary" @click="openPurchaseModal">
    {{ $tc('verignDvAccessibility.entityPurchaseButton') }}
</mt-button>